import React from 'react';
import { ISearchQuery } from './ISearchQuery';
import { Form, Formik } from 'formik';
import { DateRangeFilter } from 'ui-toolkit/components/DataGrid/DateRangeFilter';
import { NumberField, TextField } from 'ui-toolkit';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { HeaderBar } from './HeaderBar';

export interface ISearchBarProps {
  query: ISearchQuery;
  setQuery: (x: ISearchQuery) => void;
}

export const SearchBar: React.FC<ISearchBarProps> = ({ query, setQuery }) => {
  const updateDateRange = (newDate: any, setFieldValue: any) => {
    setFieldValue('createdAtDate', newDate);
  };
  return (
    <Formik initialValues={query} enableReinitialize onSubmit={setQuery}>
      {({ values, setFieldValue }) => (
        <Form className={'w-full'}>
          <HeaderBar />
          <div className={'flex flex-row w-full gap-1 items-center px-2'}>
            <div className={'basis-44'}>
              <DateRangeFilter
                defaultValue={values.createdAtDate}
                onFilter={(value) => updateDateRange(value, setFieldValue)}
                showClear
                fixed
              />
            </div>
            <TextField className={'basis-32'} name={`fileNumber`} placeholder={'File Number'} />
            <TextField className={'basis-52'} name={`borrowerName`} placeholder={'Borrower Name'} />
            <TextField className={'grow'} name={'propertyAddress'} placeholder={'Property Address'} />
            <TextField className={'basis-40'} name={'bankAccountName'} placeholder={'Account Name'} />
            <div className={'basis-32'}>
              <NumberField name={`amountCents`} mode="currency" placeholder={'Amount'} valueIsCents />
            </div>
            <ButtonTW className={'basis-36'} type={'submit'} data-test-id={`expected-search-button`}>
              Search
            </ButtonTW>
          </div>
        </Form>
      )}
    </Formik>
  );
};
